export const ACCOUNT_GRANT_EXPIRES_SOON_DAYS = 14;
